import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { toast as sonnerToast } from 'sonner';

import { cn } from '../components/lib/utils';

export enum EToasterStatus {
  ERROR = 'error',
  SUCCESS = 'success'
}

type ToasterStyles = {
  iconVariant: string;
  iconColor: string;
  titleClass: string;
  descriptionClass: string;
  closeButtonClass: string;
};

const toastShellClassName =
  'group flex w-[368px] items-start gap-3 rounded-[10px] border border-base-border bg-base-card py-3 pl-4 pr-10 absolute bottom-0 h-max hover:cursor-pointer [&:not(:first-child)>div]:data-[expanded=false]:opacity-0';

export const showToast = ({
  message,
  description,
  status
}: {
  message: string;
  description?: string;
  status: EToasterStatus;
}) => {
  const statusStyles: Record<EToasterStatus, ToasterStyles> = {
    success: {
      iconVariant: 'fa-regular fa-circle-check',
      iconColor: 'text-emerald-600',
      titleClass: 'text-emerald-700',
      descriptionClass: 'text-emerald-600/90',
      closeButtonClass: 'text-emerald-600/70'
    },
    error: {
      iconVariant: 'fa-regular fa-circle-exclamation',
      iconColor: 'text-red-600',
      titleClass: 'text-red-600',
      descriptionClass: 'text-red-600/90',
      closeButtonClass: 'text-red-600/70'
    }
  };

  const styles = statusStyles[status];

  return sonnerToast(message, {
    description,
    unstyled: true,
    closeButton: true,
    icon: (
      <FontAwesomeIcon
        icon={styles.iconVariant}
        className={cn(
          'mt-1 shrink-0 text-base leading-none',
          styles.iconColor
        )}
      />
    ),
    classNames: {
      toast: toastShellClassName,
      title: cn(
        'text-p-s font-medium leading-5 line-clamp-2',
        styles.titleClass
      ),
      description: cn(
        'text-p-s leading-5 line-clamp-6',
        status === EToasterStatus.SUCCESS ? 'font-normal' : 'font-medium',
        styles.descriptionClass
      ),
      closeButton: cn(
        'opacity-0 group-hover:opacity-100 absolute top-2 right-2 w-4 h-4 [&>svg]:h-4 [&>svg]:w-4',
        styles.closeButtonClass
      )
    }
  });
};
